import axios from 'axios';

export function payment360(orderId: string, channel: string, buyerType?: string) {
  return axios.post(`${window.apiBase}/public/payment`, { orderId, channel, buyerType }).then(response => {
    localStorage.setItem('orderId', orderId);
    sessionStorage.setItem('orderId', orderId);
    return response.data;
  });
}
